import { ReactComponent as FlagIcon } from "./svg/kr-flag.svg";
import "../flag-icon.scss";

export const KRFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
